import { RhinoError } from '../../error';

export function createMissingCollectionIdError() {
  return new RhinoError('CONFIGURATION', `The category doesn't contain collection id`);
}
